import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import * as API from 'services';

import { formatContractedForeignBusinessList } from './contracted-foreign-business.helper';
import { ContractedForeignBusinessActions } from './contracted-foreign-business.redux';
import {
	IPayloadGetContractedForeignBusinessListRequest,
	TPayloadAddForeignBusinessInfoRequest,
	TPayloadDeleteForeignBusinessInfoRequest,
} from './contracted-foreign-business.type';

export function* getContractedForeignBusiness(
	action: PayloadAction<IPayloadGetContractedForeignBusinessListRequest>
) {
	const { callback, ...restParams } = action.payload;

	try {
		// call api
		const res: API.ApiResponseSuccess<API.GetContractedForeignBusinessResponse> =
			yield API.getContractedForeignBusiness(restParams);
		const data = formatContractedForeignBusinessList(res?.data);

		yield put(
			ContractedForeignBusinessActions.getContractedForeignBusinessListSuccess({
				content: data?.content,
				total: res?.data?.total,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(
			ContractedForeignBusinessActions.getContractedForeignBusinessListFailure()
		);
	}
}

export function* deleteContractedForeignBusiness(
	action: PayloadAction<TPayloadDeleteForeignBusinessInfoRequest>
) {
	const { callback, ids } = action.payload;

	try {
		yield API.deleteContractedForeignBusiness(ids);

		yield put(
			ContractedForeignBusinessActions.deleteContractedForeignBusinessSuccess()
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(
			ContractedForeignBusinessActions.deleteContractedForeignBusinessFailure()
		);
	}
}

export function* addContractedForeignBusiness(
	action: PayloadAction<TPayloadAddForeignBusinessInfoRequest>
) {
	const { callback, ids } = action.payload;

	try {
		yield API.addContractedForeignBusiness(ids);

		yield put(
			ContractedForeignBusinessActions.addContractedForeignBusinessSuccess()
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(
			ContractedForeignBusinessActions.addContractedForeignBusinessFailure()
		);
	}
}
